import wealth from "constants/wealth";
import { Col, Container, Row } from "react-bootstrap";
import { Jumbotron } from "sections";
import parse from 'html-react-parser';
import '../personal.css';
import EnquiryForm from "components/forms/EnquiryForm";
import briefcase from 'assets/images/briefcase.svg'

function UnitTrust() {
  return (
    <div>
      <section className="section jumbotron">
        <Jumbotron badgeText="Wealth Management" title={`Participate into a diversified portfolio even with <span className="jumbotron-subtitle-2">small investment amount<span>`} buttonText="Talk to us" />
      </section>
      <section className="wealth">
        <Container>
          <Row className="bg-light p-4 rounded-4">
            <Col md={6} className="container">
              <img src={wealth.unitTrust.about.image} width="90%" className="rounded-3" alt="unit trust" data-aos="fade-down" />
            </Col>
            <Col md={6} className="d-flex flex-column align-items-center justify-content-center unit-trust-about">
              <div className="container mt-5" data-aos="fade-down" data-aos-delay="100">
                <h4>{parse(wealth.unitTrust.about.title)}</h4>
                <div className="my-4">{parse(wealth.unitTrust.about.description)}</div>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <section className="wealth">
        <Container>
          <Row className="py-4 rounded-4">
              <Col md={6} className="d-flex flex-column align-items-center justify-content-center unit-trust-about">
                <div className="container mt-5" data-aos="fade-down" data-aos-delay="100">
                  <h4>{parse(wealth.unitTrust.partners.title)}</h4>
                  <div className="my-4 text-black-50">
                    <div className="mb-3">{parse(wealth.unitTrust.partners.subtitle)}</div>
                    {wealth.unitTrust.partners.description.map((description, index) => (
                      <div className="eligibility-list" data-aos="zoom-in-down">
                        <img src={briefcase} width="16" alt="outline_check"/>
                        {parse(description)}
                      </div>
                    ))}
                  </div>
                  <div className="my-4 text-black-50">{wealth.unitTrust.partners.footnotes}</div>
                </div>
              </Col>
              <Col md={6} className="container">
                <img src={wealth.unitTrust.partners.image} height="100%" width="100%" className="rounded-3" alt="unit trust" data-aos="fade-right" />
              </Col>
          </Row>
          <Row>
            <Col className="py-4">
              <h3>{wealth.unitTrust.question.title}</h3>
              <div className="py-4 text-black-50">{parse(wealth.unitTrust.question.description)}</div>
            </Col>
          </Row>
          <Row>
            <Col className="py-4">
              <h3>{wealth.unitTrust.disclaimer.title}</h3>
              <div className="py-4 text-black-50">{parse(wealth.unitTrust.disclaimer.description)}</div>
            </Col>
          </Row>
          <Row className="my-5 py-5">
            <Col md={4}>
              <h3>Let's connect!</h3>
              <span className="text-black-50">Share your information, and we'll get back to you with the answers you need.</span>
            </Col>
            <Col md={8}>
              <EnquiryForm />
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  )
}

export default UnitTrust;